import r from"react";const e=t=>{return Array.isArray(t)?t.map((r=>e(r))):(a=t,a?.type===r.Fragment?e(t?.props.children):"string"==typeof t?r.createElement("span",null,t):t);var a};export{e as safeRenderChildren};
//# sourceMappingURL=safeRenderChildren.js.map
